<!-- eslint-disable -->
<template lang="pug">
    .search-element
        div(@click="$emit('search')")
            svg-icon.search-element__icon(
                name="search",
                size="base",
            )
        cs-input(
            type="text",
            :value="value",
            :placeholder="placeholder"
            @input="input",
        )
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            value: {
                type: [String, Number, Boolean],
                default: null
            },
            placeholder: {
                type: String,
                default: ''
            },
        },
        methods: {
            input (event) {
                this.$emit('input', event)
            },
        }
    }
</script>

<style lang="scss" scoped>
    $icon-width: 32px;
    $border-width: 1px;

    .search-element {
        box-sizing: content-box;
        display: block;
        position: relative;
        width: 100%;
        min-height: 40px;
        text-align: left;
    }

    .search-element .cs-input:not(:first-child) {
        padding-right: 40px;
    }

    .search-element__icon {
        position: absolute;
        width: 40px;
        right: 1px;
        top: 1px;
        text-align: center;
        line-height: 16px;
        box-sizing: border-box;
        margin: 0;
        text-decoration: none;
        cursor: pointer;

        color: $hsl-color-blue-56;
        border-radius: $border-radius-6;
        height: calc(100% - 2 * #{$border-width});
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        &:before {
            display: none;
        }
    }
</style>
